<div class="google-login-wrapper">
  <ng-content></ng-content>
</div>